var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 25.0024C3.4291 24.9986 2.78306 24.8566 2.1875 24.5858C1.54339 24.3018 0.994611 23.8385 0.606714 23.2511C0.218816 22.6638 0.00819386 21.9771 0 21.2733V3.7316C0.00819386 3.02774 0.218816 2.34111 0.606714 1.75372C0.994611 1.16634 1.54339 0.703015 2.1875 0.419099C2.92863 0.0690316 3.75319 -0.0657999 4.56723 0.0299686C5.38126 0.125737 6.15202 0.448254 6.79167 0.960767L17.4167 9.7316C17.8333 10.0633 18.1698 10.4847 18.4011 10.9644C18.6324 11.4442 18.7525 11.9699 18.7525 12.5024C18.7525 13.035 18.6324 13.5607 18.4011 14.0404C18.1698 14.5202 17.8333 14.9416 17.4167 15.2733L6.79167 24.0441C6.02579 24.6652 5.0694 25.0036 4.08333 25.0024Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletTriangle);
export default __webpack_public_path__ + "static/media/bullet_triangle.29fbe65e7b1337b0d3efe34bd2f1dfd7.svg";
export { ForwardRef as ReactComponent };